import api from './api';

const messageService = {
  getByTicketId: async (ticketId) => {
    console.log('Fetching messages for ticket:', ticketId);
    const response = await api.get(`/api/private/message/ticket/${ticketId}`);
    console.log('Messages response:', response.data);
    return response.data;
  },

  create: async (messageData) => {
    console.log('Creating message:', messageData);
    const response = await api.post('/api/private/message', messageData);
    console.log('Create message response:', response.data);
    return response.data;
  }
};

export default messageService; 